/**
 * Rótulos do resultado do contato com testes (TrialOutreachOutcome.php),
 * usados no card da empresa e no histórico do Contato com testes.
 */

export const OUTCOME_OPTIONS = [
  { value: 'responded', label: 'Respondeu', tone: 'blue' },
  { value: 'coming_back', label: 'Vai voltar', tone: 'green' },
  { value: 'discarded', label: 'Descartado', tone: 'red' },
];

export const REASON_OPTIONS = [
  { value: 'own_system', label: 'Sistema próprio' },
  { value: 'other_system', label: 'Usa outro sistema' },
  { value: 'price', label: 'Achou caro' },
  { value: 'not_now', label: 'Não precisa agora' },
  { value: 'missing_feature', label: 'Faltou recurso' },
  { value: 'other', label: 'Outro' },
];

export const NOTE_MAX_LENGTH = 500;

/**
 * @param {string|null|undefined} outcome
 * @returns {{ value: string, label: string, tone: string }|null}
 */
export function outcomeOption(outcome) {
  return OUTCOME_OPTIONS.find((item) => item.value === outcome) || null;
}

/**
 * "Descartado · Sistema próprio", "Respondeu".
 * @param {{ outcome: string, reason?: string|null }|null} value
 * @returns {string}
 */
export function describeOutcome(value) {
  const option = outcomeOption(value?.outcome);
  if (!option) return '';
  const reason = REASON_OPTIONS.find((item) => item.value === value.reason);
  return reason ? `${option.label} · ${reason.label}` : option.label;
}
